"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetFunctionalDescriptionSchema = void 0;
const zod_1 = require("zod");
exports.NetFunctionalDescriptionSchema = zod_1.default.object({
    functionalShortDescription: zod_1.default.string(),
    logicalBus: zod_1.default.object({
        logicalBusId: zod_1.default.string().optional(),
        busClassDisplayName: zod_1.default.string(),
        busClass: zod_1.default.string().optional(),
    }),
    signalAttributes: zod_1.default
        .object({
        power: zod_1.default.boolean().optional(),
        ground: zod_1.default.boolean().optional(),
        digital: zod_1.default.boolean().optional(),
        analog: zod_1.default.boolean().optional(),
        activeLow: zod_1.default.boolean().optional(),
    })
        .optional(),
    power: zod_1.default
        .object({
        type: zod_1.default.enum(['power', 'ground']),
        nominalVoltage: zod_1.default.number(),
    })
        .optional(),
});
//# sourceMappingURL=NetFunctionalDescription.js.map